
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST } from '../../../_getjson';
import isArrayInArray2D from '../../../CustomFunction/Arraymanage/isArrayInArray2D'
export default function Csprepayment(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);


    var rowStrAll = []
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        var url = parm.url
        axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            console.log(res.data);
            setListitem(res.data)
        }).finally(_ => {
        })
    }

    const selectRowProp = {
        mode: 'checkbox',
        onSelect: onRowSelect,
        onSelectAll: onSelectAll
    };
    async function onRowSelect(row, isSelected, e) {
        if (isSelected) {
            await rowStrAll.push(row)
        } else if (!isSelected) {
            let rowStrremove = [];
            rowStrremove.push(row);
            rowStrAll = await isArrayInArray2D(rowStrAll, rowStrremove, "REFDOCNO")
        }
    }
    async function onSelectAll(isSelected, rows) {
        if (isSelected) {
            for (let index = 0; index < rows.length; index++) {
                rowStrAll.push(rows[index])
            }
            console.log("rowStradd", rowStrAll);
        } else {
            rowStrAll = []
        }
    }

    const sendData = (row) => {
        if (row) {
            rowStrAll.push(row)
        }
        let resdatas = []
        resdatas.push(false)
        resdatas.push("Csprepayment") //ส่งกลับเพื่อเป็นเงือนไขที่มา
        resdatas.push(rowStrAll)
        props.resdata(resdatas)
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    return (
        <div className="panel-body DivTable">
            <button onClick={sendData}>ตกลง</button>
            <br></br>
            <BootstrapTable
                data={listitem}
                options={{
                    onRowDoubleClick: sendData,
                    noDataText: "ไม่พบข้อมูล"
                }}
                selectRow={selectRowProp}
                height='650'
            >
                <TableHeaderColumn dataAlign="center" width="45" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='DOCNO' dataAlign="center" editable={false} isKey> ใบเตรียมจ่าย </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="13%" dataField='DOCDATE' editable={false}> วันที่เตรียมจ่าย </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REMARK' dataAlign="left" editable={false}> หมายเหตุ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='BANKAMOUNT' dataAlign="left" editable={false}> จำนวนเงิน </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='CURRNAME' dataAlign="left" editable={false}> สกุลเงิน </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='BATHPAYAMOUNT' dataAlign="left" editable={false}> ยอดเงินบาท </TableHeaderColumn>
            </BootstrapTable>
            <button onClick={sendData}>ตกลง</button>

            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />



        </div>)
}
Csprepayment.prototype = {
    parm: PropTypes.array,
}
